import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const Offers = lazy(() => import("../pages/Offers"));
const OfferDetails = lazy(() => import("../pages/OfferDetails"));
const OfferRequisitionDetails = lazy(() => import("../pages/OfferRequisitionDetails"));

export const offersRoutes = [
  {
    path: "/offers",
    children: [
      {
        path: "",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Offers />
          </Suspense>
        ),
      },
      {
        path: ":id",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <OfferDetails />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/offer-requisitions/:id",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <OfferRequisitionDetails />
      </Suspense>
    ),
  },
];
